import React from 'react';
import { TEST_IDS } from 'shared';
import { Button, Stack, Tooltip } from '@mui/material';

import { SubmitOptions } from '../../../types';
import { DeskingTestIds } from '../../../constants';

interface Props {
  isProposalLoading: boolean;
  hasUnavailableProducts: boolean;
  onSubmitForm: (options: SubmitOptions) => Promise<void>;
}

export const PanelFormActions = ({ onSubmitForm, isProposalLoading, hasUnavailableProducts }: Props) => (
  <Tooltip
    arrow
    disableFocusListener={!hasUnavailableProducts}
    disableHoverListener={!hasUnavailableProducts}
    disableTouchListener={!hasUnavailableProducts}
    title={
      hasUnavailableProducts
        ? 'The menu has products that are no longer available, are expired or are inactive. Please remove them before proceeding by clicking "Remove Product" on any product that has that button in the menu above.'
        : ''
    }
  >
    <Stack direction="row" gap="0.5rem" width="fit-content" data-testid={DeskingTestIds.PanelFormActions}>
      <Button
        variant="contained"
        loading={isProposalLoading}
        disabled={hasUnavailableProducts}
        onClick={() => onSubmitForm({ isDraft: false })}
        data-testid={TEST_IDS.desking.panelActions.send}
      >
        Send
      </Button>

      <Button
        loading={isProposalLoading}
        disabled={hasUnavailableProducts}
        onClick={() => onSubmitForm({ isDraft: true })}
        data-testid={TEST_IDS.desking.panelActions.saveAsDraft}
      >
        Save as draft
      </Button>
    </Stack>
  </Tooltip>
);
